import { LabThemeToggle } from '@/components/LabThemeToggle';
import { useLabCaptureMode } from '@/hooks/useLabCaptureMode';
import { useLabTheme } from '@/hooks/useLabTheme';
import { NavLink, Outlet } from 'react-router-dom';

const NAV: { to: string; label: string; end?: boolean }[] = [
  { to: '/', label: 'Overview', end: true },
  { to: '/matrix/hero-stock', label: 'Hero stock' },
  { to: '/matrix/block/Hero_Editorial_Split', label: 'Block' },
  { to: '/matrix/grid/Hero_Editorial_Split', label: 'Compare blocks' },
  // Package layout — hidden until site page bootstrap logic is clearer; route still at /matrix/tiers
  { to: '/matrix/parity', label: 'Batch Checkup' },
  // Coverage — hidden for now; route still live at /matrix/coverage
];

export function LabShell() {
  const { theme, toggle } = useLabTheme();
  const captureMode = useLabCaptureMode();

  return (
    <div className="lab-shell" data-app="design-lab" data-lab-capture={captureMode ? '1' : undefined}>
      {!captureMode ? (
        <header className="lab-nav">
          <div className="lab-brand">
            <p className="lab-brand__eyebrow">hubA</p>
            <p className="lab-brand__title">Design Lab</p>
          </div>
          <nav className="lab-nav__links" aria-label="Design Lab">
            {NAV.map(({ to, label, end }) => (
              <NavLink key={to} to={to} end={end} className="lab-nav__link">
                {label}
              </NavLink>
            ))}
          </nav>
          <LabThemeToggle theme={theme} onToggle={toggle} />
        </header>
      ) : null}
      <main className={captureMode ? 'lab-main lab-main--capture' : 'lab-main'}>
        <Outlet />
      </main>
    </div>
  );
}
